import { Badge } from '@react-apps/design-system';
import type { BadgeProps } from '@react-apps/design-system';
import type { SalesDeliveryStatus } from '../../domain/entities/delivery.entity';

type BadgeVariant = NonNullable<BadgeProps['variant']>;

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '---';
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(new Date(iso));
}

// --- Status: rótulo PT-BR + variante de cor do Badge ---

const DELIVERY_STATUS: Record<
  SalesDeliveryStatus,
  { label: string; variant: BadgeVariant }
> = {
  pending: { label: 'Pendente', variant: 'info' },
  delivered: { label: 'Entregue', variant: 'success' },
  failed: { label: 'Falhou', variant: 'error' },
  undelivered: { label: 'Não entregue', variant: 'warning' },
  skipped: { label: 'Produto desconhecido', variant: 'warning' },
  skipped_debt_cycle: { label: 'Ciclo de acordo', variant: 'default' },
};

export const DELIVERY_STATUS_OPTIONS: {
  value: SalesDeliveryStatus;
  label: string;
}[] = (Object.keys(DELIVERY_STATUS) as SalesDeliveryStatus[]).map((status) => ({
  value: status,
  label: DELIVERY_STATUS[status].label,
}));

export function DeliveryStatusBadge({
  status,
}: {
  status: SalesDeliveryStatus;
}) {
  const s = DELIVERY_STATUS[status] ?? {
    label: status,
    variant: 'default' as BadgeVariant,
  };
  return <Badge variant={s.variant}>{s.label}</Badge>;
}

export function Mono({ children }: { children: React.ReactNode }) {
  return <span className="break-all font-mono text-xs">{children}</span>;
}

export function Field({
  label,
  value,
}: {
  label: string;
  value: React.ReactNode;
}) {
  return (
    <div className="space-y-1">
      <p className="text-(--color-text-secondary) text-xs font-medium uppercase tracking-wide">
        {label}
      </p>
      <div className="text-(--color-text-primary) text-sm">
        {value === null || value === undefined || value === '' ? (
          <span className="text-(--color-text-secondary)">---</span>
        ) : (
          value
        )}
      </div>
    </div>
  );
}
